<div>
    <div class="grid">
        <div class="col-12">
            <h3 style="text-align: center; padding: 2px 5px;">
                {{ 'Mg_Param' | translate }}
            </h3>
        </div>
    </div>
    <div class="grid">
        <div class="col-12 sm:col-12 md:col-12 lg:col-9 padtop">
        </div>
        <div class="col-12 sm:col-12 md:col-12 lg:col-3 padtop">
            <h4>
                <div class="badge grey">{{ 'Vers_Num' | translate }} {{ version }}</div>
            </h4>
        </div>
    </div>
    <div class="grid">
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <!-- Paramétrage smtp -->
            <table class="table head" style="font-size: 14px;">
                <thead>
                <div class="grid paramt">
                    <div class="col-6 word-break-all margauto">{{ 'ParamSmtp' | translate }}</div>
                    <div class="col-6">{{ 'Value' | translate }}</div>
                </div>
                </thead>
                <tbody>
                    @for (request of requests; track request; let i = $index) {
                        <tr>
                            @switch (request.typepref) {
                                @case (48) {
                                    <!-- 48 : SMTP IP -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <input
                                                        type="text"
                                                        [(ngModel)]="smtpHost.datapref"
                                                        inputId="smtpHost"
                                                        pInputText
                                                >
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (49) {
                                    <!-- 49: SMTP port -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <p-inputNumber
                                                        [(ngModel)]="smtpPort.datapref"
                                                        inputId="smtpPort" mode="decimal" [min]="1" [max]="9999"
                                                >
                                                </p-inputNumber>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (50) {
                                    <!-- 50 : SMTP user -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <input
                                                        type="text"
                                                        [(ngModel)]="smtpUser.datapref"
                                                        inputId="smtpUser"
                                                        pInputText
                                                >
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (51) {
                                    <!-- 51 : SMTP pass -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <p-password
                                                        [(ngModel)]="smtpPass.datapref"
                                                        inputId="smtpPass"
                                                        [feedback]="false"
                                                >
                                                </p-password>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (52) {
                                    <!-- 52 : SMTP from -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <input
                                                        type="text"
                                                        [(ngModel)]="smtpFrom.datapref"
                                                        inputId="smtpFrom"
                                                        pInputText
                                                >
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (53) {
                                    <!-- 53 : SMTP auth -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="smtpAuth"
                                                               [(ngModel)]="smtpAuthBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (60) {
                                    <!-- 60 : SMTP encryption -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <p-dropdown class="col-6 align"
                                                        [options]="availableSmtpEncryption"
                                                        [(ngModel)]="smtpEncryption.datapref"
                                            >
                                            </p-dropdown>
                                        </div>
                                    </td>
                                }                                
                            }
                        </tr>
                    }
                <div class="col-12 align">
                    <button class="save-color-button" pButton type="button" (click)="onSaveSmtp(true)"
                            label="{{'Save' | translate}}"></button>
                    <button class="save-color-button" pButton type="button" (click)="onSaveSmtp(false)"
                            label="{{'Test' | translate}}"></button>
                </div>
                </tbody>
            </table>
        </div>
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <!-- Bannette -->
            <table class="table head" style="font-size: 14px;">
                <thead>
                <div class="grid paramt">
                    <div class="col-6">{{ 'Basket' | translate }}</div>
                    <div class="col-6">{{ 'Value' | translate }}</div>
                </div>
                </thead>
                <tbody>
                    @for (request of requests; track request; let i = $index) {
                        <tr>
                            @switch (request.typepref) {
                                @case (36) {
                                    <!-- 36 : Couleur bannette mail -->
                                    <td>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="ml-3 flex-1"> {{ request.label }}</div>
                                            <div class="flex-1">
                                                <p-colorPicker name="bskColorMail"
                                                               [(ngModel)]="bskColorMail.datapref"></p-colorPicker>
                                            </div>
                                            <div class="flex-1 mr-3">
                                                <input type="text" pInputText [(ngModel)]="bskColorMail.datapref"/>
                                            </div>
                                            <div class="flex-none flex-shrink-0">
                                                <button id="bskColorMailBt" type="button" pButton
                                                        class="save-color-button" pRipple icon="pi pi-save"
                                                        (click)="onChangeValueColor(36, 'bskMailColor', bskColorMail.datapref)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (37) {
                                    <!-- 37 : Couleur bannette collect -->
                                    <td>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="ml-3 flex-1"> {{ request.label }}</div>
                                            <div class="flex-1">
                                                <p-colorPicker name="bskColorMail"
                                                               [(ngModel)]="bskColorCollect.datapref"></p-colorPicker>
                                            </div>
                                            <div class="flex-1 mr-3">
                                                <input type="text" pInputText [(ngModel)]="bskColorCollect.datapref"/>
                                            </div>
                                            <div class="flex-none flex-shrink-0">
                                                <button id="bskColorCollectBt" type="button" pButton
                                                        class="save-color-button" pRipple icon="pi pi-save"
                                                        (click)="onChangeValueColor(37, 'bskColorCollectBt', bskColorCollect.datapref)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (38) {
                                    <!-- 38 : Couleur bannette publish -->
                                    <td>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="ml-3 flex-1"> {{ request.label }}</div>
                                            <div class="flex-1">
                                                <p-colorPicker name="bskColorMail"
                                                               [(ngModel)]="bskColorPublish.datapref"></p-colorPicker>
                                            </div>
                                            <div class="flex-1 mr-3">
                                                <input type="text" pInputText [(ngModel)]="bskColorPublish.datapref"/>
                                            </div>
                                            <div class="flex-none flex-shrink-0">
                                                <button id="bskColorPublishBt" type="button" pButton
                                                        class="save-color-button" pRipple icon="pi pi-save"
                                                        (click)="onChangeValueColor(38, 'bskPublishColor', bskColorPublish.datapref)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (39) {
                                    <!-- 39 : Couleur bannette action -->
                                    <td>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="ml-3 flex-1"> {{ request.label }}</div>
                                            <div class="flex-1">
                                                <p-colorPicker name="bskColorMail"
                                                               [(ngModel)]="bskColorAction.datapref"></p-colorPicker>
                                            </div>
                                            <div class="flex-1 mr-3">
                                                <input type="text" pInputText [(ngModel)]="bskColorAction.datapref"/>
                                            </div>
                                            <div class="flex-none flex-shrink-0">
                                                <button id="bskColorActionBt" type="button" pButton
                                                        class="save-color-button" pRipple icon="pi pi-save"
                                                        (click)="onChangeValueColor(39, 'bskPublishColor', bskColorAction.datapref)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (40) {
                                    <!-- 40 : Couleur bannette input -->
                                    <td>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="ml-3 flex-1"> {{ request.label }}</div>
                                            <div class="flex-1">
                                                <p-colorPicker name="bskColorMail"
                                                               [(ngModel)]="bskColorInput.datapref"></p-colorPicker>
                                            </div>
                                            <div class="flex-1 mr-3">
                                                <input type="text" pInputText [(ngModel)]="bskColorInput.datapref"/>
                                            </div>
                                            <div class="flex-none flex-shrink-0">
                                                <button id="bskColorInputBt" type="button" pButton
                                                        class="save-color-button" pRipple icon="pi pi-save"
                                                        (click)="onChangeValueColor(40, 'bskPublishColor', bskColorInput.datapref)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (41) {
                                    <!-- 41 : Couleur bannette output -->
                                    <td>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="ml-3 flex-1"> {{ request.label }}</div>
                                            <div class="flex-1">
                                                <p-colorPicker name="bskColorMail"
                                                               [(ngModel)]="bskColorOutput.datapref"></p-colorPicker>
                                            </div>
                                            <div class="flex-1 mr-3">
                                                <input type="text" pInputText [(ngModel)]="bskColorOutput.datapref"/>
                                            </div>
                                            <div class="flex-none flex-shrink-0">
                                                <button id="bskColorOutputBt" type="button" pButton
                                                        class="save-color-button" pRipple icon="pi pi-save"
                                                        (click)="onChangeValueColor(41, 'bskPublishColor', bskColorOutput.datapref)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (42) {
                                    <!-- 42 : Couleur bannette system -->
                                    <td>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="ml-3 flex-1"> {{ request.label }}</div>
                                            <div class="flex-1">
                                                <p-colorPicker name="bskColorMail"
                                                               [(ngModel)]="bskColorSystem.datapref"></p-colorPicker>
                                            </div>
                                            <div class="flex-1 mr-3">
                                                <input type="text" pInputText [(ngModel)]="bskColorSystem.datapref"/>
                                            </div>
                                            <div class="flex-none flex-shrink-0">
                                                <button id="bskColorSystemBt" type="button" pButton
                                                        class="save-color-button" pRipple icon="pi pi-save"
                                                        (click)="onChangeValueColor(42, 'bskPublishColor', bskColorSystem.datapref)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (55) {
                                    <!-- Extensions bannettes -->
                                    <td>
                                    <div class="grid">
                                        <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                        <div class="col-6 align margt-5">
                                            <p-multiSelect [options]="extList" [(ngModel)]="selectedExt.datapref" (onPanelHide)="onChangeValue(55)"></p-multiSelect>

                                        </div>
                                    </div>
                                    </td>
                                }
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <table class="table head" style="font-size: 14px;">
                <thead>
                <div class="grid paramt">
                    <div class="col-6 word-break-all margauto">{{ 'Divers' | translate }}</div>
                    <div class="col-6">{{ 'Value' | translate }}</div>
                </div>
                </thead>
                <tbody>
                    @for (request of requests; track request; let i = $index) {
                        <tr>
                            @switch (request.typepref) {
                                @case (34) {
                                    <!-- 34 : Image de fond -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <p-fileUpload #fileUploader name="file"
                                                              class="size_cent"
                                                              [multiple]="false"
                                                              [showUploadButton]="false"
                                                              [showCancelButton]="false"
                                                              [chooseLabel]="browseLabel"
                                                              invalidFileTypeMessageSummary={{fileMsg}}
                                                              invalidFileTypeMessageDetail=""
                                                              accept="image/*" maxFileSize="1000000"
                                                              (onUpload)="onUpload($event)"
                                                >
                                                    <ng-template pTemplate="toolbar">
                                                        <span style="float:right">
                                                        <button id="saveBack" type="button" pButton pRipple icon="pi pi-upload"
                                                                (click)="onClickUpload(fileUploader, 'setbackgroundimage')">
                                                        </button>
                                                        </span>
                                                    </ng-template>
                                                    <ng-template let-file pTemplate="file">
                                                        <i
                                                                class="icons8-trash-can margin-right iconstyle"
                                                                (click)="removeItem(file, fileUploader)"
                                                                style="color:red"
                                                        ></i>
                                                        {{ file.name }}
                                                    </ng-template>
                                                </p-fileUpload>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (35) {
                                    <!-- 35 : Logo -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <p-fileUpload #fileUploaderLogo name="file"
                                                              class="size_cent"
                                                              [multiple]="false"
                                                              [showUploadButton]="false"
                                                              [showCancelButton]="false"
                                                              [chooseLabel]="browseLabel"
                                                              invalidFileTypeMessageSummary={{fileMsg}}
                                                              invalidFileTypeMessageDetail=""
                                                              accept="image/*" maxFileSize="1000000"
                                                              (onUpload)="onUploadLogo($event)"
                                                >
                                                    <ng-template pTemplate="toolbar">
                                                    <span style="float:right">
                                                    <button id="saveLogo" type="button" pButton pRipple icon="pi pi-upload"
                                                            (click)="onClickUpload(fileUploaderLogo, 'setlogo')">
                                                    </button>
                                                    </span>
                                                    </ng-template>
                                                    <ng-template let-file pTemplate="file">
                                                        <i
                                                                class="icons8-trash-can margin-right iconstyle"
                                                                (click)="removeItem(file, fileUploaderLogo)"
                                                                style="color:red"
                                                        ></i>
                                                        {{ file.name }}
                                                    </ng-template>
                                                </p-fileUpload>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (65) {
                                    <!-- 65 : Ecran par défaut général -->
                                    <td>
                                      <div class="grid">
                                        <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                        <p-dropdown class="col-6 align"
                                          [options]="availablePageList"
                                          [(ngModel)]="screen.datapref"
                                          (onChange)="onChangeValue(65)"
                                          >
                                        </p-dropdown>
                                      </div>
                                    </td>                
                                }
                                @case (23) {
                                    <!-- 23 : Taille maxi envoi fichier -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <p-dropdown class="col-6 align"
                                                        [options]="availableLoadMax"
                                                        [(ngModel)]="loadMax.datapref"
                                                        (onChange)="onChangeValue(23)"
                                            >
                                            </p-dropdown>
                                        </div>
                                    </td>
                                }
                                @case (25) {
                                    <!-- 25 : Durée token -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <p-inputNumber
                                                        (onBlur)="onBlurToken($event)"
                                                        [(ngModel)]="tokenDuration.datapref"
                                                        inputId="inToken" mode="decimal" [min]="15" [max]="9999"
                                                >
                                                </p-inputNumber>
                                                <button id="saveToken" type="button" pButton pRipple icon="pi pi-save"
                                                        (click)="onChangeValue(25)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <table class="table head" style="font-size: 14px;">
                <thead>
                <div class="grid paramt">
                    <div class="col-6 word-break-all margauto">{{ 'Divers' | translate }}</div>
                    <div class="col-6">{{ 'Value' | translate }}</div>
                </div>
                </thead>
                <tbody>
                    @for (request of requests; track request; let i = $index) {
                        <tr>
                            @switch (request.typepref) {
                                @case (27) {
                                    <!-- 27 : Accès aux préférences -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="prefAccess" (onChange)="onChangeValue(27)"
                                                               [(ngModel)]="prefAccessBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (43) {
                                    <!-- 43 : Mode visu document -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <p-dropdown class="col-6 align"
                                                        [options]="availableModeViewDoc"
                                                        [(ngModel)]="modeViewDoc.datapref"
                                                        (onChange)="onChangeValue(43)"
                                            >
                                            </p-dropdown>
                                        </div>
                                    </td>
                                }
                                @case (44) {
                                    <!-- 44 : Date par défaut recherche plein texte -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto "> {{ request.label }}</div>
                                            <div class="col-6 p-inputgroup">
                                                <p-dropdown styleClass="width-100"
                                                            placeholder="{{'Sel_OpDt1' | translate}}"
                                                            [options]="availableListActionDate"
                                                            [(ngModel)]="defaultFullTextDate.datapref"
                                                            [editable]="true">
                                                </p-dropdown>
                                                <button id="saveDateFullText" type="button" pButton pRipple
                                                        icon="pi pi-save" (click)="onChangeValueDate(44)"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (46) {
                                    <!-- 46 : Activation mentions -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="activmention" (onChange)="onChangeValue(46)"
                                                               [(ngModel)]="activNotifBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (47) {
                                    <!-- 47 : Recalcul des positions des docks -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <button class="margin margb-5 sm:reset-btn p-button-danger" pButton
                                                        type="button" (click)="onCompDock()"
                                                        label="{{'Apply' | translate}} {{'Confirm_Param_D1' | translate}}"></button>
                                            </div>
                                        </div>
                                    </td>
                                }
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="col-12 sm:col-12 md:col-6 lg:col-6 xl:col-4 padtop">
            <table class="table head" style="font-size: 14px;">
                <thead>
                <div class="grid paramt">
                    <div class="col-6 word-break-all margauto">{{ 'Divers' | translate }}</div>
                    <div class="col-6">{{ 'Value' | translate }}</div>
                </div>
                </thead>
                <tbody>
                    @for (request of requests; track request; let i = $index) {
                        <tr>
                            @switch (request.typepref) {
                                @case (56) {
                                    <!-- 56 : Déconnexion azure -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="disconnectAzure" (onChange)="onChangeValue(56)"
                                                    [(ngModel)]="discntAzureBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }                                
                                @case (57) {
                                    <!-- 57 : Durée message toast -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto "> {{ request.label }}</div>
                                            <p-dropdown class="col-6 align"
                                                        placeholder="{{'ToastDuration' | translate}}"
                                                        [options]="availableToastDuration"
                                                        [(ngModel)]="toastDurationValue.datapref"
                                                        (onChange)="onChangeValue(57)">
                                            </p-dropdown>
                                        </div>
                                    </td>
                                }
                                @case (58) {
                                    <!-- 58 : Afficher les fenêtres de confirmation -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="displayConfirm" (onChange)="onChangeValue(58)"
                                                    [(ngModel)]="displayConfirmBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (59) {
                                    <!-- 59 : Afficher les recherches par type -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="requestOrder" (onChange)="onChangeValue(59)"
                                                    [(ngModel)]="requestOrderBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (63) {
                                    <!-- 63 : Réorganisation des docks des bannettes -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="bskDockReorder" (onChange)="onChangeValue(63)"
                                                    [(ngModel)]="bskDockReorderBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }
                                @case (64) {
                                    <!-- 64 : Réorganisation des docks des recherches -->
                                    <td>
                                        <div class="grid">
                                            <div class="col-6 word-break-all margauto"> {{ request.label }}</div>
                                            <div class="col-6 align margt-5">
                                                <p-inputSwitch name="srcDockReorder" (onChange)="onChangeValue(64)"
                                                    [(ngModel)]="srcDockReorderBool"></p-inputSwitch>
                                            </div>
                                        </div>
                                    </td>
                                }
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
<app-item-confirm [key]="'compdock'" [severity]="'alert'" (onAccept)="compDocks()"></app-item-confirm>
